export default () => ({
	code: '',
	CODE_LENGTH: 4,
	loading: false,
	countdown: false,
	time: null,
	dateUntil: null
})
